import React from "react";
import Select from "react-select";

const FiltersContainer = ({ data, setValue }) => {
  return (
    <div className="flex-grow-1 flex-md-grow-0">
      <Select
        className="custom-filter-button"
        defaultValue={data[0]}
        onChange={(v) => setValue(v)}
        options={data}
      />
    </div>
  );
};

export default FiltersContainer;
